import actions from '../actions/actionTypes';

export const INITIAL_STATE = {
  data: {
    brands: [],
    sizes: [],
    colors: [],
    priceTypes: [],
    patterns: [],
    styles: [],
    contexts: [],
    availability: [],
  },
  loading: false,
  error: null,
};

const productFilterOptions = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actions.FILTER_OPTIONS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actions.FILTER_OPTIONS_SUCCESS:
      return {
        ...state,
        data: payload || {},
        loading: false,
      };
    case actions.FILTER_OPTIONS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default productFilterOptions;
